import React from 'react';

/**
 * Hover/focus tooltip. Anchors above the trigger and stays inside the viewport
 * on narrow screens (the old version used a fixed `top-10` offset that pushed
 * the bubble outside its card).
 *
 * The wrapper is `inline-flex` and sizes to its content, so pass `w-full` through
 * `className` when the trigger should stretch.
 *
 * `align` controls which edge the bubble hangs from. A centred bubble on a
 * trigger that sits at the right edge of a card runs off small screens, so
 * right-aligned triggers should pass `align="right"` (and vice versa).
 */
const ALIGNMENT = {
  center: 'left-1/2 -translate-x-1/2',
  left: 'left-0',
  right: 'right-0',
};

export default function Tooltip({ message, children, className = '', align = 'center' }) {
  return (
    <span className={`group/tip relative inline-flex ${className}`} tabIndex={0}>
      {children}
      <span
        role="tooltip"
        className={`pointer-events-none absolute bottom-full z-40 mb-2 w-max max-w-[min(260px,calc(100vw-2rem))] scale-90 rounded-xl border border-white/15 bg-black/95 px-3 py-2 text-xs font-normal normal-case not-italic leading-snug tracking-normal text-white opacity-0 shadow-xl shadow-black/60 backdrop-blur transition duration-150 group-hover/tip:scale-100 group-hover/tip:opacity-100 group-focus/tip:scale-100 group-focus/tip:opacity-100 ${
          ALIGNMENT[align] || ALIGNMENT.center
        }`}
      >
        {message}
      </span>
    </span>
  );
}
